import "../../chunk-D57E6H3M.mjs";

// src/domain/chat/types.ts
var ChatRole = /* @__PURE__ */ ((ChatRole2) => {
  ChatRole2["User"] = "user";
  ChatRole2["Assistant"] = "assistant";
  ChatRole2["System"] = "system";
  return ChatRole2;
})(ChatRole || {});
var ChatStreamStatus = /* @__PURE__ */ ((ChatStreamStatus2) => {
  ChatStreamStatus2["Idle"] = "Idle";
  ChatStreamStatus2["Waiting"] = "Waiting";
  ChatStreamStatus2["InProgress"] = "InProgress";
  ChatStreamStatus2["Success"] = "Success";
  ChatStreamStatus2["Failure"] = "Failure";
  return ChatStreamStatus2;
})(ChatStreamStatus || {});
export {
  ChatRole,
  ChatStreamStatus
};
//# sourceMappingURL=types.mjs.map